<template>
    <v-layout>
        <v-flex>
            <v-card>
                <v-card-title>
                    <h3 class="headline mb-0 admin-header">Datafeed</h3>
                    <v-btn text icon color="grey lighten-1" @click="refresh(pagination)"><v-icon>fas fa-sync</v-icon></v-btn>
                </v-card-title>
                <v-card-text>
                    <v-layout row wrap>
                        <span class="subheading"><b>Filters:</b></span>
                        <v-icon v-if="showFilters" @click="showFilters = !showFilters">fal fa-chevron-up</v-icon>
                        <v-icon v-if="!showFilters" @click="showFilters = !showFilters">fal fa-chevron-down</v-icon>
                    </v-layout>
                        <v-form v-model="valid" v-if="showFilters" @submit.prevent>
                    <v-layout row wrap>
                        <v-flex xs11>
                            <v-layout wrap>
                                <!-- <v-flex xs2 ml-4>
                                    <v-autocomplete
                                    v-model="orgId"
                                    :items="organizations"
                                    label="Organization"
                                        item-text="text"
                                        item-value="value">
                                    </v-autocomplete>
                                </v-flex> -->
                                <v-flex xs2 ml-4>
                                    <v-autocomplete
                                    v-model="orgId"
                                    :items="organizations"
                                    label="Organization"
                                        item-text="text"
                                        item-value="value">
                                    </v-autocomplete>
                                </v-flex>
                                <v-flex xs2 ml-4>
                                    <v-text-field label="Data" v-model="data"></v-text-field>
                                </v-flex>
                                <v-flex xs2 ml-4>
                                    <v-text-field label="Type" v-model="type"></v-text-field>
                                </v-flex>
                                <v-flex xs2 ml-4>
                                    <v-text-field label="External Id" v-model="externalId"></v-text-field>
                                </v-flex>
                                <v-flex xs2 ml-4>
                                    <v-text-field label="Disposition Message" v-model="dispositionMsg"></v-text-field>
                                </v-flex>
                                <v-flex xs2 ml-4>
                                    <v-text-field label="Sender" v-model="sender"></v-text-field>
                                </v-flex>
                                <v-flex xs4 ml-4>
                                    <div class="date-time-container">
                                        <span class="date-selection-wrapper">
                                        <date-selection
                                            :min-date="minDate"
                                            :max-date="maxDate"
                                            :date-text="dateText"
                                            :value="dateValue"
                                            @range-selected="handleDateRangeUpdate"
                                        ></date-selection>
                                        </span>
                                    </div>
                                </v-flex>
                            </v-layout>
                        </v-flex>
                        <v-flex xs1>
                          <button onsubmit="false" class="btn btn-primary" @click="applyFilters" :disabled="!valid">Apply</button>
                          <button onsubmit="false" class="btn btn-default" @click="resetFilters">Reset</button>
                        </v-flex>
                    </v-layout>
                        </v-form>
                    <v-layout row wrap>
                        <v-flex xs12>
                            <v-data-table
                              :items="datafeed.content"
                              :loading="loading"
                              :headers="headers"
                              :options.sync="pagination"
                              :footer-props="{'items-per-page-options': [5, 10, 15, 20, 50, 100]}"
                              :server-items-length="totalItems" class="elevation-1"
                            >
                            <template v-slot:item.updatedDate="{item}">
                                <td>{{formatDateTime(item.updatedDate)}}</td>
                              </template>
                              <template v-slot:item.orgId="{item}">
                                <td>{{item.org ? item.org.id : null}}</td>
                              </template>
                              <template v-slot:item.orgName="{item}">
                                <td>{{item.org ? item.org.name : null}}</td>
                              </template>
                              <template v-slot:item.data="{item}">
                                <td>{{item.data}}</td>
                              </template>
                              <template v-slot:item.type="{item}">
                                <td>{{item.type}}</td>
                              </template>
                              <template v-slot:item.externalId="{item}">
                                <td>{{item.externalId}}</td>
                              </template>
                              <template v-slot:item.dispositionMsg="{item}">
                                <td>{{item.dispositionMsg}}</td>
                              </template>
                              <template v-slot:item.sender="{item}">
                                <td>{{item.sender}}</td>
                              </template>
                            </v-data-table>
                        </v-flex>
                    </v-layout>
                </v-card-text>
            </v-card>
        </v-flex>
    </v-layout>
</template>
<script>
import { mapState, mapActions, mapGetters } from 'vuex'
import _ from 'lodash'
import moment from 'moment-timezone';
import Utility from './utility'
import dateSelectionPopup from '../../../../vueComponents/dateSelectionPopup/dateSelectionPopup.vue'
import LoginService from "../../../../services/login.service";
export default {
    components: {
        'date-selection': dateSelectionPopup
    },
    computed: {
        ...mapGetters('user', {
            organizations: 'getOrganizationsTextValue',
            isSUPro: 'isSUPro'
        }),
        ...mapGetters('menus', {
          findRouteTitle: 'findRouteTitle'
        }),
        routeTitle: {
          get() {
            return this.findRouteTitle(this.$route.name) || this.title
          }
        },
        dateText: function() {
            let dateFormat = 'MMM D, YYYY'
            return `${moment(this.dateValue.startDate).format(dateFormat)} - ${moment(this.dateValue.endDate).format(dateFormat)}`
        }
    },
    data() {
        return {
            minDate: moment.max([
                this.getCurrentMoment().subtract(10, 'year').startOf('month'),
                moment("1-1-2022", "MM-DD-YYYY")
            ]).toDate(),
            maxDate: this.getCurrentMoment().endOf('day').toDate(),
            dateValue: this.getDefaultDateRange(),
            datafeed: {
                "content": [],
                "totalElements": 0
            },
            loading: false,
            search: '',
            pagination : {
                    descending: true,
                    page: 1,
                    rowsPerPage: 10, // -1 for All",
                    itemsPerPage: 10,
                    sortBy: ["updatedDate"]
            },
            totalItems: 0,
            headers: [
                // {text: 'Id', align: 'left', sortable: true, value: 'id'},
                {text: 'Updated', align: 'left', sortable: true, value: 'updatedDate'},
                {text: 'Org Id', align: 'left', sortable: true, value: 'orgId'},
                {text: 'Org Name', align: 'left', sortable: true, value: 'orgName'},
                {text: 'Data', align: 'left', sortable: true, value: 'data'},
                {text: 'Type', align: 'left', sortable: false, value: 'type'},
                {text: 'External Id', align: 'left', sortable: true, value: 'externalId'},
                {text: 'Disposition Message', align: 'left', sortable: true, value: 'dispositionMsg'},
                {text: 'Sender', align: 'left', sortable: false, value: 'sender'}
            ],
            orgId: null,
            data: null,
            type: null,
            externalId: null,
            dispositionMsg: null,
            sender: null,
            showFilters: true,
            valid: false 
        }
    },
    watch: {
        pagination: {
            async handler () {
                await this.refresh(this.pagination)
            }, deep: true
        }
    },
    methods: {
        async refresh(pagination) {

            const { page, itemsPerPage, sortBy, sortDesc } = pagination

            let sort = ""
            if (sortBy && sortBy.length) {
                sort = sortBy[0] + "," + (sortDesc && sortDesc.length && sortDesc[0] ? 'desc' : 'asc')
            }

            let filter = Utility.buildQueryString(['orgId', 'data', 'type', 'externalId', 'dispositionMsg', 'sender', 'from', 'to'],
                              [this.orgId, this.data, this.type, this.externalId, this.dispositionMsg, this.sender, 
                              moment(this.dateValue.startDate).subtract(1, 'days').format('YYYY-MM-DD'), moment(this.dateValue.endDate).add(1, 'days').format('YYYY-MM-DD')], ['data', 'type', 'externalId', 'dispositionMsg', 'sender'])

            this.loading = true

            this.datafeed = await this.$store.dispatch('crossorg/getDatafeed',
                {filter, size: itemsPerPage || 10, page: page ? page - 1 : 0, sort})

            this.totalItems = this.datafeed.totalElements

            this.loading = false
        },
        formatDateTime(val) {
            return moment(val).isValid() ? moment(val).format('MM/DD/YYYY, h:mm:ss a') : val
        },
        async resetFilters() {
            this.key = null
            this.value = null

            this.orgId = null
            this.data = null
            this.type = null
            this.externalId = null
            this.dispositionMsg = null
            this.sender = null
            this.dateValue = this.getDefaultDateRange()

            await this.refresh(this.pagination)

        },
        async applyFilters() {
            await this.refresh(this.pagination)
        },
        handleDateRangeUpdate(dv) {
            this.dateValue = dv
        },
        getCurrentMoment() {
            return moment.tz(_.get(LoginService.userObject, 'timezoneId', ''));
        },
        getTimezoneText() {
            return _.get(LoginService.userObject, 'timezoneDisplay', '');
        },
        getDateFormat() {
            return DATE_FORMAT;
        },
        getDefaultDateRange() {
            return {
                startDate: this.getCurrentMoment().subtract(1, 'month').startOf('day'),
                endDate: this.getCurrentMoment().endOf('day')
            }
        }
    }
}
</script>
<style lang="scss" scoped>
  .date-time-container {
      display: table-cell;
      text-align: right;
      align-self: center;

        .date-selection-wrapper {
            .dateSelection .custom-date-picker {
            padding: 10px;
            height: 40px;
            border-radius: var(--border-radius);
            border: 1px solid #D0D0D0;
            background-color: #FFFFFF;
            display: inline-block;

            #dateRangePicker {
                right: 0;
            }
        }
    }
  }
</style>